module.exports = __webpack_public_path__ + "static/media/location_rovaniemi.b6339f63.jpg";